import React from 'react';
import { useRef } from 'react';
import emailjs from 'emailjs-com';
import './css/contact.css';

export default function Contact() {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_em3p814',
        'template_87meivb',
        form.current,
        '0B885uLFcyco8LmjV'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };
  return (
    <>
      <div className="container" id="contact">
        <h1>Contact</h1>

        <div className="contact my-4">
          <div className="container-fluid row d-flex">
            <div className="contact_left col-md-6 p-4">
              <article className="contact_left_option mb-3">
                <h4>
                  <b>Email</b>
                  <i class="bi bi-envelope-paper p-2"></i>
                </h4>
                <h6>raihanultomal@gmail.com</h6>
                <a
                  href="mailto:raihanultomal@gmail.com"
                  rel="noreferrer"
                  target="_blank"
                  className="btn btn-outline-danger"
                >
                  <i class="bi bi-send-fill"></i>
                </a>
              </article>

              <article className="contact_left_option">
                <h4>
                  <b>WhatsApp</b> <i class="bi bi-whatsapp"></i>
                </h4>
                <h6>+8801521401218</h6>
                <a
                  href="https://api.whatsapp.com/send?phone=+8801521401218"
                  rel="noreferrer"
                  target="_blank"
                  className="btn btn-outline-danger"
                >
                  <i class="bi bi-send-fill"></i>
                </a>
              </article>
            </div>
            <div className="contact_right_option col-md-6 p-4">
              <form ref={form} onSubmit={sendEmail}>
                <div class="mb-3 ">
                  <input
                    type="name"
                    name="name"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div class="mb-3 ">
                  <input
                    type="text"
                    name="subject"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Subject of email"
                    required
                  />
                </div>
                <div class="mb-3 ">
                  <input
                    type="email"
                    name="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter you Email Id"
                    required
                  />
                  <div id="emailHelp" class="form-text">
                    We'll never share your email with anyone else.
                  </div>
                </div>

                <textarea
                  name="message"
                  class="form-control"
                  rows="7"
                  placeholder="Your message"
                  required
                ></textarea>

                <button type="submit" class="btn btn-primary mt-3">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div>
        <iframe
          title="raihanul"
          width="100%"
          height="200"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          src="https://maps.google.com/maps?width=100%25&amp;height=200&amp;hl=en&amp;q=Dhaka+(Dhaka,%20Bangladesh)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
        >
          <a href="https://www.maps.ie/distance-area-calculator.html">
            distance maps
          </a>
        </iframe>
      </div>
    </>
  );
}
